export interface BaseEnergyAnalyticResponseInterface {
  customerBk: string;
  systemBk: string;
}

export interface BaseEnergyAnalyticsParamsInterface {
  customerBk?: string;
  systemBk?: string;
}

// region Safety Recommendation models
export interface SafetyRecommendationDataInterface extends BaseEnergyAnalyticResponseInterface {
  systemState: ActionStateEnum;
  numberOfStableStrings: number;
  requiredActions: ComponentStateInterface[];
  recommendedActions: ComponentStateInterface[];
}

export interface ComponentStateInterface {
  name: string;
  componentBk: string;
  componentState: ActionStateEnum;
  kpiStates: KpiStateInterface[];
}

export interface KpiStateInterface {
  kpi: SafetyKPIEnum;
  state: ActionStateEnum;
  issueTypes: KpiIssueTypeEnum[];
}

export enum SafetyKPIEnum {
  TEMPERATURE = 'TEMPERATURE',
  RESISTANCE = 'RESISTANCE',
  MIN_CELL_VOLTAGE = 'MIN_CELL_VOLTAGE',
}

export enum ActionStateEnum {
  REQUIRED = 'ACTION_REQUIRED',
  RECOMMENDED = 'ACTION_RECOMMENDED',
  STABLE = 'STABLE',
}

export enum KpiIssueTypeEnum {
  ANOMALY = 'ANOMALY',
  TREND = 'TREND',
}

export interface SafetyRecommendationComponentDetailsParamsInterface extends BaseEnergyAnalyticsParamsInterface {
  componentBk: string;
}

export interface KpiStateDetailsInterface {
  kpi: SafetyKPIEnum;
  state: ActionStateEnum;
  issueType: KpiIssueTypeEnum;
  timestamps: Date[];
  outlierComponentValues: number[];
  stableComponentsValues: number[];
}

export interface SafetyRecommendationComponentDetailsInterface extends BaseEnergyAnalyticResponseInterface {
  componentBk: string;
  kpiStates: KpiStateDetailsInterface[];
}

export interface MailNotificationSettingsResponse {
  userMail: string;
  customerBk: string;
  systemBk: string;
  safetyNotificationsEnabled: boolean;
}

export enum SafetyState {
  ACTION_REQUIRED = 'ACTION_REQUIRED',
  ACTION_RECOMMENDED = 'ACTION_RECOMMENDED',
  STABLE = 'STABLE',
}
// endregion

// region System Ingestion Statistics Models
export interface SystemIngestionStatistics {
  lastSeen: Date | null;
}
// endregion

// region has siblings effect
export interface GetSiblingEffectResponse {
  hasSiblingEffect: boolean;
}
// endregion

// region Health KPI Models
export enum HealthKPIAggregationScope {
  PER_ENTITY = 'per-entity',
  ACROSS_ENTITIES = 'across-entities',
}

export enum HealthKPIAggregationType {
  AVERAGE = 'avg',
  MAX = 'max',
  MIN = 'min',
  NONE = 'none',
}

export enum HealthKPIEnum {
  DCR = 'dcr',
  EFC = 'efc',
  SOH = 'soh-c',
  TEMPERATURE_SPREAD = 'module-temperature-spread',
  VOLTAGE_SPREAD = 'cell-voltage-spread',
}

export interface HealthKPILatestParameters {
  levelBk: string;
  aggregationScope: HealthKPIAggregationScope;
  aggregationType: HealthKPIAggregationType;
  kpi: HealthKPIEnum;
}

export interface HealthKPILatestRequestParameters extends BaseEnergyAnalyticsParamsInterface, HealthKPILatestParameters {}

export interface HealthKPIAggregatedParameters extends HealthKPILatestParameters {
  startDate: string;
  endDate: string;
}
export interface HealthKPIAggregatedRequestParameters extends BaseEnergyAnalyticsParamsInterface, HealthKPIAggregatedParameters {}

export enum StandardSensorBk {
  DCR = 'twaice_dc_resistance',
  EFC = 'twaice_equivalent_full_cycles_cumulative',
  SOH = 'twaice_soh',
  TEMPERATURE_SPREAD = 'twaice_module_temperature_spread',
  VOTLAGE_SPREAD = 'twaice_cell_voltage_spread',
}
export interface HealthKPIComponent {
  componentBk?: string;
  componentName?: string;
  standardSensorBk: StandardSensorBk;
  value?: number;
  timestamp?: string;
}
export interface HealthKPILatestResponseSchema extends HealthKPILatestRequestParameters {
  data: Array<HealthKPIComponent>;
}

export interface HealthKPIAggregatedResponseSchema extends HealthKPIAggregatedRequestParameters {
  data: Array<HealthKPIComponent>;
}
// endregion
